import { render, staticRenderFns } from "./MenuComponentSelector.vue?vue&type=template&id=38da6368&scoped=true"
import script from "./MenuComponentSelector.vue?vue&type=script&lang=js"
export * from "./MenuComponentSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38da6368",
  null
  
)

export default component.exports